import { connect } from 'react-redux'
import {
  removeItem,
  removeItemWithTags,
  selectItems,
  saveSelected,
  updateItem,
  makeCopy,
  assignActiveItem,
  updateItemImageList,
  mergeItemImages,
  removeItemImage,
  addNewImageToItem,
  updateItemImage,
  createElement,
  addAllElements,
  types,
  selectTags,
  nextStep,
  stepBack,
} from '../../../actions/campaigns/elements_selector_actions'
import { selectByTags } from '../../../actions/campaigns/common_actions'
import { createLoadingSelector } from '../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_ELEMENT])

export default connect(
  (state) => ({
    id: state.campaigns?.id,
    isReady: state.campaigns?.isReady,
    isFetching: loadingSelector(state),
    elements: state.campaigns?.elements,
    tags: state.campaigns?.tags,
    elementFormData: state.campaigns?.elementFormData,
    activeItem: state.campaigns?.activeItem,
    imageDeleteCandidate: state.campaigns?.imageDeleteCandidate,
    showAdditions: state.campaigns?.showAdditions,
    showImages: state.campaigns?.showImages,
    visibleColumns: state.campaigns?.visibleColumns,
  }),
  {
    selectItems,
    removeItem,
    removeItemWithTags,
    updateItem,
    updateItemImageList,
    mergeItemImages,
    addNewImageToItem,
    updateItemImage,
    removeItemImage,
    saveSelected,
    selectTags,
    makeCopy,
    assignActiveItem,
    createElement,
    addAllElements,
    selectByTags,
    nextStep,
    stepBack,
  }
)
